<template>
  <b-container fluid>
    <b-row
      ><b-col class="col-xl-5 col-lg-6">
        <b-row>
          <b-col>
            <div class="page_title">{{ course.courseId }}</div>
          </b-col> </b-row
        ><b-row>
          <b-col
            ><p class="tsny_text indentation-left">
              {{ course.course.description }}
            </p></b-col
          >
        </b-row>
      </b-col>
      <b-col class="indentation-right">
        <b-row align-h="end"
          ><avatar class="avatar" :avatar="avatar" :width="3"
        /></b-row>
        <b-row
          ><b-col
            ><h2 class="tsny_header">
              {{ name }}
            </h2></b-col
          ></b-row
        >
        <b-row class="mb-n1"
          ><b-col
            ><div class="tsny_text text-dark">
              {{ phone }}
            </div></b-col
          ></b-row
        >
        <b-row
          ><b-col
            ><div class="tsny_text text-dark">
              {{ email }}
            </div></b-col
          ></b-row
        >
      </b-col></b-row
    >
  </b-container>
</template>

<script>
import { mapGetters } from "vuex";
import StoreConstants from "../../store/services/StoreConstants";
import * as Constants from "../../../../server/src/util/constants";
import Avatar from "../Avatar";

export default {
  name: "CourseHeader",
  components: { Avatar },
  props: {
    course: {
      type: Object,
      default: null
    }
  },
  computed: {
    ...mapGetters({ access: StoreConstants.GETTERS.ACCESS }),
    avatar: function() {
      return this.access === Constants.ACCESS_TYPES.STUDENT
        ? this.course.tutor.avatar
        : this.course.student.avatar;
    },
    name: function() {
      return this.access === Constants.ACCESS_TYPES.STUDENT
        ? `${this.course.tutor.first} ${this.course.tutor.last}`
        : `${this.course.student.first} ${this.course.student.last}`;
    },
    phone: function() {
      return this.access === Constants.ACCESS_TYPES.STUDENT
        ? `${this.course.tutor.phone}`
        : `${this.course.student.phone}`;
    },
    email: function() {
      return this.access === Constants.ACCESS_TYPES.STUDENT
        ? `${this.course.tutor.email}`
        : `${this.course.student.email}`;
    }
  }
};
</script>

<style scoped>
.indentation-left {
  margin-left: 45px;
}

.indentation-right {
  margin-right: 45px;
}

.indentation-right > div {
  text-align: right;
}

.avatar {
  padding-top: 50px;
  margin-bottom: 20px;
}
</style>
